import Icon from '../../components/Icon.vue'

Icon.register({"brands/magento":{"width":448,"height":512,"paths":[{"d":"M445.7 127.9V384L382.3 420.5V164.7L223.8 73.1 65.2 164.7 65.6 420.6 2.3 384V128.1L224.2 0 445.7 127.9zM255.6 420.5L224 438.9 192.2 420.7V164.7L128.9 201.3 129 457.2 223.9 512.1 319 457.2V201.2L255.6 164.6V420.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/magento.js
// module id = FZLY
// module chunks = 0